import React, { Component } from 'react';
import { getFileName } from '../../../../helpers/FileCaching';
import globalJson from '../../../../data/global';
import ClientLogo from '../../../App/ClientLogo/ClientLogo';
import IsNotDomestic from 'helpers/IsNotDomestic';
import VideoPlayer from '../../../App/VideoPlayer/VideoPlayer';
import classes from './Video.module.scss';

class Video extends Component {

	constructor(props) {
		super(props);

		this.globalImages = props.globalImages;

		this.videoWrapperRef = React.createRef();
	}

	render() {
		const video = this.props.content.map((item, index) => {
			const Video_html =
				<div key={index} className={classes.video} ref={this.videoWrapperRef}>
					<div className={classes['video__player-container']}>
						<VideoPlayer content={this.props.content} globalImages={this.props.globalImages} windowSize={this.props.windowSize} stylesOverride={classes.videoPlayerStyleOverride} />
					</div>
				</div>
			
			return Video_html;
		});
	
		return <section>{video}</section>
	}
}

export default Video;